import { apiClient } from './client';

export interface TrackingData {
  clickHash?: string; // For Trackfinity
  dubClickId?: string; // For DUB
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
}

export const trackingService = {
  /**
   * Send tracking data to backend
   */
  async sendTracking(data: TrackingData): Promise<void> {
    await apiClient.post('/user/tracking', data);
  },
};
